@if (getItems() | async; as items) {
  <app-interactive-carousel
    #mainIntroCarousel
    [items]="items"
    [template]="template"
    itemWidth="100%"
    [loop]="true"
    [navigation]="true"
    [autoplay]="{ delay: 5000, pauseOnMouseEnter: true, disableOnInteraction: false }"
    [showPlayPauseButton]="true"
    [hideIndicators]="false"
  ></app-interactive-carousel>
}

<ng-template #template let-item="item">
  <ng-container
    [cxComponentWrapper]="{
      flexType: item.typeCode,
      typeCode: item.typeCode,
      uid: item.uid,
    }"
  ></ng-container>
</ng-template>
